import React, { useEffect, useRef } from "react";
import ParticleBackground from "../components/ParticleBackground";
import { NavLink } from "react-router-dom";
import PowerBtn from "../components/PowerBtn";
import Footer from "../components/Footer";
import Card from "../components/Card";
import ImgCard from "../components/ImgCard";
import styled from "styled-components";
import { motion } from "framer-motion";
import profile from "../assets/Profile.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { info, info2 } from "../data/About";
import Menu from "../components/Menu";

const Box = styled.div`
  height: 200vh;
  position: relative;
  display: flex;
  align-items: center;
  @media (max-width: 1024px) {
    height: 250vh;
  }
  @media (max-width: 768px) {
    height: 300vh;
  }
`;
const Main = styled(motion.ul)`
  position: fixed;
  top: 20%;
  left: calc(10rem + 15vw);
  z-index: 30;
  display: flex;
  color: white;
  @media (max-width: 768px) {
    top: 26%;
    left: calc(3rem + 1vw);
  }
`;

const Profile = styled.div`
  position: fixed;
  overflow: hidden;
  width: 100vh;
  transform: scale(1.8);
  left: calc(15rem);
  top: calc(0rem + 15vh);

  z-index: -1 !important;

  @media (max-width: 768px) {
  }
`;

const BtnDownload = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  margin: 3rem;
  @media (max-width: 768px) {
    left: 0;
    top: 3.5rem;
  }
`;

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.5,
      duration: 0.5,
    },
  },
};

const About = () => {
  const ref = useRef(null);

  useEffect(() => {
    let element = ref.current;

    const rotate = () => {
      element.style.transform = `translateX(${-window.pageYOffset}px)`;
    };

    window.addEventListener("scroll", rotate);
    return () => {
      window.removeEventListener("scroll", rotate);
    };
  }, []);

  return (
    <Box className="z-0">
      <PowerBtn />
      <Profile>
        <img src={profile} alt="profile" />
      </Profile>

      <Menu />

      <BtnDownload>
        <NavLink
          target="_blank"
          to={{
            pathname:
              "https://drive.google.com/drive/folders/113cJEJc8OIRAKamFribnoduA6tWsYdp9?usp=sharing",
          }}
        >
          <button
            type="button"
            className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:ring-gray-100 font-bold rounded-lg text-md px-5 py-2.5 text-center inline-flex items-center sm:text-xs"
          >
            DOWNLOAD
            <FontAwesomeIcon className="ml-2 -mr-1 w-5 h-5" icon={faDownload} />
          </button>
        </NavLink>
      </BtnDownload>

      <Main
        ref={ref}
        variants={container}
        initial="hidden"
        animate="show"
        className="snap-x"
      >
        {info.map((d) => (
          <Card key={d.id} data={d} className="snap-end" />
        ))}
        {info2.map((d) => (
          <ImgCard key={d.id} data={d} className="snap-end" />
        ))}
      </Main>

      <Footer />
      <ParticleBackground />
    </Box>
  );
};

export default About;
